import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=f38853c0&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38853c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38853c0')) {
      api.createRecord('f38853c0', component.options)
    } else {
      api.reload('f38853c0', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=f38853c0&scoped=true&", function () {
      api.rerender('f38853c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5ZoDM6J7kvH/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports